import React from 'react';

const SectionHeadingWrapper = ({ children, className }) => {
    return <div className={`heading-wrapper ${className}`}>{children}</div>;
};

export default SectionHeadingWrapper;
